import type { TypedDocumentNode } from '@apollo/client';
import gql from 'graphql-tag';

export const termOfService: TypedDocumentNode<TermsOfServiceVersionResponse> = gql`
  fragment TOS on TermsOfServiceVersions {
    id
    tosLink
    tosVersion
  }
`;

export type TermsOfServiceVersionResponse = {
  id: string;
  tosLink: string;
  tosVersion: string;
};
